import { Button, Checkbox, Form, Input } from 'antd';
import { Rule } from 'antd/es/form';
import React, { useEffect, useRef } from 'react';

import { Text, useTheme } from '@desygner/ui-common-components';

import { CONSTANTS } from '../../AuthModal.data';
import {
  StyledCheckboxTextWrapper,
  StyledCheckboxTransformer,
  StyledModalSubtitle,
  getPrimaryButtonStyle,
} from '../../AuthModal.styles';
import { AuthViewPropsT, SignupPasswordViewLabelsT } from '../../AuthModal.types';
import { focusInput, handleEnter } from '../../AuthModal.utils';
import { StepHeader } from '../../components/StepHeader/StepHeader';
import { useAuthContext } from '../../context/AuthContext';

export const SignupPasswordView = ({ ...props }: AuthViewPropsT) => {
  const { ...labels } = props.labels as SignupPasswordViewLabelsT;
  const { isLoading } = useAuthContext();

  const passwordRef = useRef<any>(null);
  const form = Form.useFormInstance();

  const rules: Rule[] = [
    {
      required: true,
      message: labels.errors.client.newPasswordRequired,
    },

    {
      min: 8,
      message: labels.errors.client.newPasswordMinLenght,
    },
  ];

  useEffect(() => {
    focusInput(passwordRef);
  }, []);

  const handleChangeView = async () => {
    await form
      .validateFields()
      .then(() => {
        props.onChangeView?.('signupName');
      })
      .catch((error) => {
        console.error('Form validation failed.', error);
        return;
      });
  };

  const theme = useTheme();

  return (
    <>
      <StepHeader title={labels.title} onBack={() => props.onChangeView?.('signupCode')} />
      <StyledModalSubtitle>
        <Text size="Body">{labels.subtitle}</Text>
      </StyledModalSubtitle>

      {/* HIDDEN EMAIL FIELD FOR BROWSER AUTO FILL - DO NOT REMOVE */}
      <Form.Item name={CONSTANTS.form.emailFieldName} label={'Email'} hidden>
        <Input value={form.getFieldValue(CONSTANTS.form.emailFieldName)} />
      </Form.Item>

      <Form.Item
        label={labels.form.newPasswordLabel}
        rules={[...rules]}
        name={CONSTANTS.form.passwordFieldName}
      >
        <Input.Password
          placeholder={labels.form.newPasswordPlaceholder}
          autoComplete="new-password"
          ref={passwordRef}
          onKeyDown={(event) => handleEnter(event, handleChangeView)}
          onChange={(event) => {
            form.setFieldValue(CONSTANTS.form.passwordFieldName, event.target.value);
          }}
        />
      </Form.Item>

      {/* <StyledSpacer> */}
      <Form.Item name={CONSTANTS.form.marketingFieldName} initialValue={false}>
        <StyledCheckboxTransformer>
          <Checkbox
            onChange={(event) =>
              form.setFieldValue(CONSTANTS.form.marketingFieldName, event?.target.checked)
            }
          >
            <StyledCheckboxTextWrapper>
              <Text size="Body"> {labels.form.marketingLabel} </Text>
            </StyledCheckboxTextWrapper>
          </Checkbox>
        </StyledCheckboxTransformer>
      </Form.Item>
      {/* </StyledSpacer> */}

      <Button
        type="primary"
        loading={isLoading}
        onClick={handleChangeView}
        data-action="auth-signup-create-password"
        style={getPrimaryButtonStyle(theme)}
      >
        {labels.cta.continue}
      </Button>
    </>
  );
};
